import TextIcon from "./TextIcon";
import RichTextIcon from "./RichTextIcon";
import NumberIcon from "./NumberIcon";
import BooleanIcon from "./BooleanIcon";
import DateIcon from "./DateIcon";
import MediaIcon from "./MediaIcon";
import ObjectIcon from "./ObjectIcon";
import CodeIcon from "./CodeIcon";
import ColorIcon from "./ColorIcon";
import RefIcon from "./RefIcon";
import RefArrayIcon from "./RefArrayIcon";
import SlugIcon from "./SlugIcon";

/**
 * One field type, one glyph, everywhere.
 *
 * The field type pickers and the entry editor used to keep separate mappings —
 * the editor reached for Material icons while the content model used the local
 * set — so the same field was drawn two different ways depending on the page
 * you were on. Every surface that needs a field icon resolves it through here.
 *
 * Keys are the `type` values stored on a field; see FieldModal's fieldTypes.
 */
const FIELD_TYPE_ICONS = {
    string: TextIcon,
    richText: RichTextIcon,
    number: NumberIcon,
    boolean: BooleanIcon,
    dateTime: DateIcon,
    media: MediaIcon,
    object: ObjectIcon,
    code: CodeIcon,
    color: ColorIcon,
    reference: RefIcon,
    array: RefArrayIcon,
};

/**
 * Resolve a field to its icon component. `variant` narrows the string type,
 * which covers several distinct shapes of content.
 */
export const getFieldTypeIcon = (type, variant) => {
    if (type === "string") {
        if (variant === "slugField") return SlugIcon;
        if (variant === "longText") return RichTextIcon;
    }
    return FIELD_TYPE_ICONS[type] || TextIcon;
};

export default FIELD_TYPE_ICONS;
